export default "/fonts/SegoeUI-Italic.woff?468d86cf49a13028487ca6a2d9c4a5e2";